import { ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import jsPDF from 'jspdf';
import React from 'react';
import { Line, Pie } from 'react-chartjs-2';
import { FiSend } from "react-icons/fi";
import { GrMicrophone } from "react-icons/gr";
import { MdAttachFile } from "react-icons/md";
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend, ArcElement);



const budgetDetails = [
  { distributor: "Distributor A", amount: "$37.98 million" },
  { distributor: "Distributor B", amount: "$16.28 million" },
  { distributor: "Distributor C", amount: "$12.51 million" },
  { distributor: "Distributor D", amount: "$9.89 million" },
  { distributor: "Distributor E", amount: "$7.89 million" },
  { distributor: "Distributor F", amount: "$7.42 million" }
];

// Move the export to the top level
export const renderBudgetBreakdown = () => (
  <div className="my-6 bg-gray-300 border border-1 shadow-md p-3">
    <h3 className="text-xl font-semibold mb-4">Detailed Budget Breakdown

</h3>
<p>
  This report provides a detailed breakdown of the budget allocations across various distributors. The top distributor, Distributor A, contributed the highest amount of $37.98 million, followed by Distributor B with $16.28 million. Distributor C and Distributor D contributed $12.51 million and $9.89 million respectively. Distributor E and Distributor F had smaller contributions of $7.89 million and $7.42 million respectively.
</p>
<button onClick={downloadPDF} className="mt-4 bg-blue-600 text-white py-2 px-4 rounded">
  Download Budget
</button>
</div>
);

// Function to generate the PDF
const downloadPDF = () => {
const doc = new jsPDF();
doc.setFontSize(16);
doc.text("Budget Breakdown", 10, 10);

const description = `This report provides a detailed breakdown of the budget allocations across various distributors. The top distributor, Distributor A, contributed the highest amount of $37.98 million, followed by Distributor B with $16.28 million. Distributor C and Distributor D contributed $12.51 million and $9.89 million respectively. Distributor E and Distributor F had smaller contributions of $7.89 million and $7.42 million respectively.`;

doc.setFontSize(12);
doc.text(description, 10, 20);

doc.text(budgetDetails.map(b => `${b.distributor}: ${b.amount}`).join("\n"), 10, 40);
doc.save("budget_breakdown.pdf");
};

const MarketAnalysis = () => {
const lineData = {
labels: ['2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016'],
datasets: [
  {
    label: 'Rise and fall of romantic comedies',
    data: [10, 20, 15, 25, 30, 40, 35, 45, 50, 60, 55, 70, 65, 75, 80, 85],
    fill: false,
    borderColor: 'rgba(75, 192, 192, 1)',
  },
],
};

const pieData = {
labels: ['Distributor A', 'Distributor B', 'Distributor C', 'Distributor D', 'Distributor E', 'Distributor F'],
datasets: [
  {
    label: 'Share of various distributors',
    data: [37.98, 16.28, 12.51, 9.89, 7.89, 7.42],
    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
  },
],
};

const chartOptions = {
maintainAspectRatio: false,
responsive: true,
aspectRatio: 2,
};

return (
  <>
  <SEO
    title="Market Analysis"
    description="Analyse the film market for your project with ProducerBuddy's AI-powered market analysis and audience insights tools."
    url="https://producerbuddy.pilomation.com/market-analysis"
    robots="noindex, nofollow"
  />
  <SubNav/>
  <div className="bg-white p-6 rounded-lg shadow-lg">
  <h2 className="text-lg font-semibold mb-4">Analysis Board</h2>

  <div className="relative flex justify-center items-center p-3 bg-gray-10">
    <input
      type="search"
      id="search"
      className="block w-50 p-3 pl-12 pr-24 text-sm text-gray-900 border border-gray-50 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      placeholder="Findout different trends for your productions..."
      required
    />

    <div className="relative inset-y-0 right-5 flex items-center pr-3 space-x-2">
      <MdAttachFile className="text-xl text-gray-500 dark:text-gray-400" />
      <GrMicrophone className="text-xl text-gray-500 dark:text-gray-400" />
      <FiSend className="text-xl text-gray-500 dark:text-blue-400" />
    </div>
  </div>

  {/* Budget Breakdown Section */}
  <div>{renderBudgetBreakdown()}</div>

  {/* Charts Section */}
  <div className="flex justify-around gap-4 p-5">
    <div className="h-24">
      <Line data={lineData} options={chartOptions} height={150} width={350} />
    </div>
    <div className="h-24">
      <Pie data={pieData} options={chartOptions} height={400} width={400} />
    </div>
  </div>
</div>
  </>

);
};

export default MarketAnalysis;

